import {historyBackButtonDirective} from './history-back-button/history-back-button.directive';
import loaderModule                 from './loader/loader';
import tableResponsiveModule        from './table-responsive/table-responsive';
import emptyModule                  from './empty/empty';
import getAvatarFilter              from './get-avatar/get-avatar.filter';
import { destroyModule }            from './destroy/destroy';
import { uploadAvatarModule }       from './upload-avatar/upload-avatar';
import { fileChangeDirective }      from './file-change/file-change.directive';
import {unsafeFilter}               from './unsafe/unsafe.filter';
import { layLoadingDirective }      from './lazyloading.directive';
import { tableSearchDirective, tableSortDirective } from "./tables.directives";
import { simpleSearchComponent }    from "./simpleSearch/simpleSearch";
import { uploadModule }             from "./upload/upload";

const UtilityModule = angular
  .module('utility', [
    loaderModule.name,
    tableResponsiveModule.name,
    emptyModule.name,
    destroyModule.name,
    uploadAvatarModule.name,
    uploadModule.name,
  ])
  .directive('fileChange', fileChangeDirective.create)
  .directive('historyBackButton', historyBackButtonDirective.create)
  .directive('lazyLoading', layLoadingDirective.create)
  .directive('tableSort', tableSortDirective.create)
  .directive('tableSearch', tableSearchDirective.create)
  .filter('getAvatar', getAvatarFilter)
  .filter('unsafe', unsafeFilter)
    .component("simpleSearch", simpleSearchComponent);

export default UtilityModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/utility/utility.js
 **/